import { PREFIX_BUTTON } from '../PaymentMethodList/components/PaymentMethod/constant';

import { PAYMENT_METHODS } from '~constants/paymentMethods';

export const ENABLED_TO_SHOW_PAYMENT_NAMES = [
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.cash}`,
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.card}`,
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.powertranzGuest}`,
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.ingenico}`,
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.mercadopago}`,
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.mercantilGuest}`,
  `${PREFIX_BUTTON}_${PAYMENT_METHODS.directClickToPay}`
];
